import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LANGUAGES, useLanguage } from "../i18n";
import "./AccountSettings.css";

export default function AccountSettings() {
  const { language, setLanguage, t } = useLanguage();
  const [authState, setAuthState] = useState("loading");
  const [saveState, setSaveState] = useState("");

  useEffect(() => {
    let active = true;
    fetch("/api/me", { credentials: "include" })
      .then(async (response) => ({ ok: response.ok, data: await response.json() }))
      .then(({ ok, data }) => {
        if (active) setAuthState(ok && data?.ok && data?.user?.id ? "signed-in" : "signed-out");
      })
      .catch(() => { if (active) setAuthState("signed-out"); });
    return () => { active = false; };
  }, []);

  const handleLanguageChange = async (event) => {
    const nextLanguage = event.target.value;
    setSaveState("saving");
    const saved = await setLanguage(nextLanguage, true);
    setSaveState(saved ? "saved" : "error");
  };

  return (
    <main className="account-settings-page">
      <div className="account-settings-card">
        <span className="account-settings-eyebrow">BUBLYUP</span>
        <h1>{t("accountSettings")}</h1>
        {authState === "loading" ? (
          <p className="account-settings-message" role="status">{t("accountLanguageSaving")}</p>
        ) : authState === "signed-out" ? (
          <>
            <p className="account-settings-message">{t("signInToEditSettings")}</p>
            <Link className="account-settings-link" to="/register">{t("login")}</Link>
          </>
        ) : (
          <>
            <p className="account-settings-description">{t("accountLanguageDescription")}</p>
            <label className="account-settings-label" htmlFor="account-language">{t("accountLanguage")}</label>
            <select id="account-language" value={language} onChange={handleLanguageChange}>
              {LANGUAGES.map((item) => <option key={item.code} value={item.code}>{item.label}</option>)}
            </select>
            {saveState && <p className={`account-settings-message ${saveState === "error" ? "is-error" : ""}`} role="status">{t(saveState === "saving" ? "accountLanguageSaving" : saveState === "saved" ? "accountLanguageSaved" : "accountLanguageSaveError")}</p>}
          </>
        )}
        <Link className="account-settings-back" to="/my-profile">{t("backToProfile")}</Link>
      </div>
    </main>
  );
}
